import {
  Box,
  Button,
  Card,
  CardMedia,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import managerLessonApi from "api/managerLesson";
import BACKGROUND_1234 from "assets/img/slide_month_1234.png";
import BACKGROUND_5678 from "assets/img/slide_month_5678.png";
import BACKGROUND_9101112 from "assets/img/slide_month_9101112.png";
import {ListSlideMonth, SlideMonth} from "models/managerLesson";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import useStyles from "../style";

import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import EventNoteIcon from "@material-ui/icons/EventNote";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import { useTranslation } from "react-i18next";

export default function CarouselMonthMobile() {
  const classes = useStyles();
  const { t } = useTranslation();

  const currentMonth = new Date().getMonth() + 1;
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [listSlideMonth, setListSlideMonth] = useState<SlideMonth[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const res: ListSlideMonth<SlideMonth> = await managerLessonApi.getSlideMonth(year);
        setListSlideMonth(res.lessionOverview);
      } catch (error) {}
    })();
  }, [year]);

  const getThemeByMonth = (month: number) => {
    if (month < 5) {
      return {
        accent: "#E11D48",
        bg: "#FFF1F2",
        border: "#FECDD3",
        gradient: "linear-gradient(135deg, #F43F5E 0%, #E11D48 100%)",
        trackBg: "#FFE4E6",
      };
    } else if (month < 9) {
      return {
        accent: "#D97706",
        bg: "#FFFBEB",
        border: "#FDE68A",
        gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)",
        trackBg: "#FEF3C7",
      };
    } else {
      return {
        accent: "#2563EB",
        bg: "#EFF6FF",
        border: "#BFDBFE",
        gradient: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
        trackBg: "#DBEAFE",
      };
    }
  };

  return (
    <Box className={classes.container}>
      {/* Header Banner */}
      <Box className={classes.headerBanner}>
        <Box className={classes.headerTitleGroup}>
          <Box className={classes.headerIconPill}>
            <EventNoteIcon style={{ fontSize: 22 }} />
          </Box>
          <Box>
            <Typography className={classes.headerTitle}>
              BÀI HỌC THEO THÁNG
            </Typography>
            <Typography className={classes.headerSubtitle}>
              Chọn tháng để học
            </Typography>
          </Box>
        </Box>

        <FormControl variant="outlined" className={classes.formControl}>
          <Select
            value={year}
            onChange={(e: any) => setYear(Number(e.target.value))}
            displayEmpty
            IconComponent={ExpandMoreIcon}
            renderValue={(selected: any) => (
              <Box style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <CalendarTodayIcon style={{ fontSize: 18, color: "#2563EB" }} />
                <span>Năm {selected}</span>
              </Box>
            )}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  borderRadius: 16,
                  marginTop: 8,
                  boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
                  border: "1px solid #E2E8F0",
                  maxHeight: 280,
                  width: "calc(100vw - 32px)",
                  maxWidth: 320,
                },
              },
            }}
          >
            {Array.from(new Array(10)).map((_, index) => {
              const yearValue = index + 2020;
              return (
                <MenuItem
                  key={yearValue}
                  value={yearValue}
                  style={{
                    borderRadius: 8,
                    margin: "2px 6px",
                    fontWeight: year === yearValue ? 800 : 600,
                    fontSize: "0.9rem",
                    color: year === yearValue ? "#2563EB" : "#334155",
                    backgroundColor: year === yearValue ? "#EFF6FF" : "transparent",
                  }}
                >
                  Năm {yearValue}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>

      {/* Vertical Full ListView Cards stack */}
      <Box style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {listSlideMonth?.map((item, index) => {
          const monthTheme = getThemeByMonth(item.month);
          const percent = item.noTotalLession > 0 
            ? Math.round((item.noWatchedLession / item.noTotalLession) * 100) 
            : 0;

          return (
            <Box key={index}>
              <Card className={classes.card}>
                <CardMedia
                  className={classes.contentMedia}
                  image={
                    item.month < 5
                      ? BACKGROUND_1234
                      : item.month < 9
                      ? BACKGROUND_5678
                      : BACKGROUND_9101112
                  }
                >
                  <Box className={classes.mediaTopRow}>
                    {item.month === currentMonth && (
                      <Box className={classes.activeMonthChip}>
                        <WhatshotIcon style={{ fontSize: 14, marginRight: 4 }} /> THÁNG HIỆN TẠI
                      </Box>
                    )}
                  </Box>
                  <Typography className={classes.monthTitle}>
                    THÁNG {item.month < 10 ? `0${item.month}` : item.month}
                  </Typography>
                </CardMedia>

                <Box className={classes.cardBody}>
                  <Typography className={classes.progressLabel}>
                    {t("home.carousel.sobaihocdahoanthanh")}
                  </Typography>

                  <Box className={classes.totalWatchedRow}>
                    <Typography className={classes.totalWatchedNum} style={{ color: monthTheme.accent }}>
                      {item.noWatchedLession}
                    </Typography>
                    <Typography className={classes.totalWatchedDenom}>
                      / {item.noTotalLession} bài ({percent}%)
                    </Typography>
                  </Box>

                  <Box className={classes.progressBarTrack}>
                    <Box
                      className={classes.progressBarFill}
                      style={{
                        width: `${percent}%`,
                        backgroundColor: monthTheme.accent,
                      }}
                    />
                  </Box>

                  <Button
                    className={classes.btn_detail}
                    style={{ background: monthTheme.gradient }}
                    endIcon={<ArrowForwardIcon />}
                    onClick={() =>
                      navigate({
                        pathname: "/list-lesson",
                        search: `year=${year}&month=${
                          item.month < 10 ? `0${item.month}` : item.month
                        }`,
                      })
                    }
                  >
                    {t("home.vaohoc")}
                  </Button>
                </Box>
              </Card>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
